export enum RoomMode {
    Public = "public",
    Private = "private",
}
